import React from 'react';

import { JiraIcon } from '@atlaskit/logo/jira-icon';
import { TopNavStart } from '@atlaskit/navigation-system/layout/top-nav';
import { AppLogo } from '@atlaskit/navigation-system/top-nav-items';
import { CustomTitle } from '@atlaskit/navigation-system/top-nav-items/custom-title';

import { MockTopBar } from '../common/mock-top-bar';

export const CustomTitleExample = (): React.JSX.Element => {
	return (
		<MockTopBar>
			<TopNavStart sideNavToggleButton={null}>
				<AppLogo href="http://www.atlassian.design" icon={JiraIcon} name="Jira" label="Home page" />
				<CustomTitle>Custom title</CustomTitle>
			</TopNavStart>
		</MockTopBar>
	);
};

export default CustomTitleExample;
